export const CFP_MODULES = [
  {
    slug: 'cfp-modulo-1',
    label: 'CFP - Módulo 1',
    description: 'Planejamento Financeiro: Princípios, Processos e Habilidades',
  },
  {
    slug: 'cfp-modulo-2',
    label: 'CFP - Módulo 2',
    description: 'Gestão Financeira',
  },
  {
    slug: 'cfp-modulo-3',
    label: 'CFP - Módulo 3',
    description: 'Planejamento de Investimentos & Gestão de Ativos',
  },
  {
    slug: 'cfp-modulo-4',
    label: 'CFP - Módulo 4',
    description: 'Planejamento de Aposentadoria',
  },
  {
    slug: 'cfp-modulo-5',
    label: 'CFP - Módulo 5',
    description: 'Planejamento de Seguros & Gestão de Risco',
  },
  {
    slug: 'cfp-modulo-6',
    label: 'CFP - Módulo 6',
    description: 'Planejamento Tributário',
  },
  {
    slug: 'cfp-modulo-7',
    label: 'CFP - Módulo 7',
    description: 'Planejamento Patrimonial & Sucessório',
  },
  {
    slug: 'cfp-modulo-8',
    label: 'CFP - Módulo 8',
    description: 'Psicologia no Planejamento Financeiro',
  },
];
